const tdClasses =
  // ☢️ Table internal borders intentionally made lighter with  border-muted
  "relative border-b border-zinc-200/40 dark:border-muted text-sm font-normal text-gray-900 table-cell hover:bg-muted group-hover:bg-muted whitespace-nowrap leading-5 dark:text-gray-400 truncate items-center"
const tdSelectedBgClasses = "bg-muted"
const tdBgClasses = "bg-background"
const tdSpacingClasses = "py-2.5 px-4"
const tHeadClasses =
  "text-left border-b bg-muted text-xs leading-4 font-medium text-primary uppercase tracking-wider table-cell bg-opacity-75 backdrop-filter"
const tHeadStickyClasses = "sticky z-20 top-0"
const tableClasses = "w-full overflow-auto border-separate border-spacing-0"

export const tableBaseThemes = {
  tdClasses,
  tdSelectedBgClasses,
  tdBgClasses,
  tdSpacingClasses,
  tHeadClasses,
  tHeadStickyClasses,
  tableClasses,
}
